export default __webpack_public_path__ + "static/media/03_box 2.ba88c640.gif";